






















































































































































import i18n from "@/libs/i18n";
import { useCustomersStore } from "@/store/useCustomersStore";
import { BillingPeriodMonthsType } from "@/types/billingMonths.type";
import { ref, Ref } from "@vue/composition-api";
import { BCol, BContainer, BFormCheckbox, BFormGroup, BFormInput, BFormSelect, BRow } from "bootstrap-vue";
import { storeToRefs } from "pinia";

export default {
    components: { BFormGroup, BFormCheckbox, BFormInput, BFormSelect, BContainer, BRow, BCol },
    setup() {
        const { customerSettings, editableCustomerSettings } = storeToRefs(useCustomersStore());

        editableCustomerSettings.value.push(
            "billingMonths",
            "customUserPriceMonthly",
            "customUserPriceYearly",
            "limitUsers"
        );

        const limitUsersEnabled: Ref<boolean> = ref(customerSettings.value.limitUsers > -1);
        const customUserPriceMonthlyEnabled: Ref<boolean> = ref(customerSettings.value.customUserPriceMonthly > -1);
        const customUserPriceYearlyEnabled: Ref<boolean> = ref(customerSettings.value.customUserPriceYearly > -1);

        const onChangeBillingPeriod = (): void => {
            if (customerSettings.value.billingMonths === BillingPeriodMonthsType.MONTHLY) {
                customUserPriceYearlyEnabled.value = false;
                customerSettings.value.customUserPriceYearly = -1;
            } else if (customerSettings.value.billingMonths === BillingPeriodMonthsType.YEARLY) {
                customUserPriceMonthlyEnabled.value = false;
                customerSettings.value.customUserPriceMonthly = -1;
            }
        };

        const onChangeCustomUserPriceMonthlyEnabled = (): void => {
            if (customUserPriceMonthlyEnabled && customerSettings.value.customUserPriceMonthly === -1) {
                customerSettings.value.customUserPriceMonthly = 0;
            } else if (!customUserPriceMonthlyEnabled) {
                customerSettings.value.customUserPriceMonthly = -1;
            }
        };

        const onChangeCustomUserPriceYearlyEnabled = (): void => {
            if (customUserPriceYearlyEnabled && customerSettings.value.customUserPriceYearly === -1) {
                customerSettings.value.customUserPriceYearly = 0;
            } else if (!customUserPriceYearlyEnabled) {
                customerSettings.value.customUserPriceYearly = -1;
            }
        };

        const onChangeLimitUsersEnabled = (): void => {
            if (limitUsersEnabled.value && customerSettings.value.limitUsers === -1) {
                customerSettings.value.limitUsers = 0;
            } else if (!limitUsersEnabled.value) {
                customerSettings.value.limitUsers = -1;
            }
        };

        return {
            customerSettings,
            billingPeriodOptions: [
                { value: BillingPeriodMonthsType.MONTHLY, text: i18n.t("settings.system.payment.monthly") },
                { value: BillingPeriodMonthsType.YEARLY, text: i18n.t("settings.system.payment.yearly") },
            ],
            BillingPeriodMonthsType,
            onChangeBillingPeriod,
            customUserPriceMonthlyEnabled,
            onChangeCustomUserPriceMonthlyEnabled,
            customUserPriceYearlyEnabled,
            onChangeCustomUserPriceYearlyEnabled,
            limitUsersEnabled,
            onChangeLimitUsersEnabled,
        };
    },
};
